import { Reveal } from "./Reveal";

export default function Intro() {
  return (
    <section data-testid="intro-section" className="relative px-6 py-32 md:py-48">
      <div className="mx-auto max-w-4xl text-center">
        <Reveal>
          <p data-testid="intro-eyebrow" className="mb-10 font-mono text-[11px] uppercase tracking-[0.5em] text-gold">
            The House
          </p>
        </Reveal>
        <Reveal delay={0.15}>
          <p data-testid="intro-text" className="font-serif text-3xl font-light leading-snug text-neutral-200 md:text-5xl md:leading-tight">
            TABI Essence of Strength is a luxury fragrance house born from remembrance —{" "}
            <em className="text-gold-light">a tribute to a life beautifully lived</em>, and a legacy that
            endures. Each creation is composed like a memory: intimate, luminous, and made to last.
          </p>
        </Reveal>
      </div>
    </section>
  );
}
